module.exports = "https://www.gc-qa.gnp.com.mx/508d2415a7179fa9621db50238442fe3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/settings_24px.svg
// module id = 1860
// module chunks = 0